export const CREATIVE_ID = {
  RANGE: 'edm-entry-range',
  BATTERY_LIFE: 'edm-entry-battery-life',
  INCENTIVES: 'edm-entry-ev-tax-credits',
  CHARGING: 'edm-entry-charging',
  COST_TO_DRIVE: 'edm-entry-cost-to-drive',
  TREEHOUSE_PROMOTION: 'treehouse-promotion',
};
